import { getApiInspectionsV1CompaniesRetrieveQueryKey, type InspectionCompany, useQueryClient } from 'api';
import { useTranslation } from 'i18n';
import { useState } from 'react';
import { Box, Instruction, Typography } from 'ui';

import { CompanyInspectorsList } from '../CompanyInspectorsList/CompanyInspectorsList';
import { InspectionCompanyMutate } from '../InspectionCompanyMutate/InspectionCompanyMutate';
import { InspectorMutate } from '../InspectorMutate/InspectorMutate';

export const CompanyAndInspectorMutate = ({
  onClose,
  company,
}: {
  onClose: () => void;
  company: InspectionCompany | null;
}) => {
  const { t } = useTranslation('orders');
  const [currentCompany, setCurrentCompany] = useState<InspectionCompany | null>(company);
  const queryClient = useQueryClient();

  return (
    <Box>
      <InspectionCompanyMutate
        onClose={() => {
          setCurrentCompany(null);
          onClose();
        }}
        onSave={(company) => {
          setCurrentCompany(company);
        }}
        {...(currentCompany
          ? { action: 'edit' as const, company: currentCompany }
          : { action: 'create' as const, company: undefined })}
      />
      <Box
        sx={{
          p: 2,
        }}
      >
        <Typography variant="h6">{t('inspectionCompany.sectionTitles.inspectors')}</Typography>
        {currentCompany ? <CompanyInspectorsList companyId={currentCompany.id} /> : null}
      </Box>
      {currentCompany ? (
        <InspectorMutate
          company={currentCompany}
          action="create"
          onSave={() => {
            queryClient.invalidateQueries({
              queryKey: getApiInspectionsV1CompaniesRetrieveQueryKey(currentCompany.id),
            });
          }}
        />
      ) : (
        <Instruction>{t('inspectionCompany.messages.createCompanyToAssignInspectors')}</Instruction>
      )}
    </Box>
  );
};
